import { render, staticRenderFns } from "./ProjectDocumentTemplateViewForm.vue?vue&type=template&id=0420218e&"
import script from "./ProjectDocumentTemplateViewForm.vue?vue&type=script&lang=js&"
export * from "./ProjectDocumentTemplateViewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports